import axios from "axios";

export const state = {
    appointmentsettings: null,
};

export const getters = {
    appointmentsettings: state => state.appointmentsettings,
};

export const mutations = {
    setAppointmentSettings(state, newValue) {
        state.appointmentsettings = newValue
    },
};

export const actions = {
    fetchAppointmentSettings({ commit }) {
        return axios.get('/appointmentsettings').then(res => {
            commit('setAppointmentSettings', res.data.settings)
        })
    },
};
